import { Suspense, lazy, useLayoutEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FooterPage from "./FooterPage/FooterPage";
import Lenis from "lenis";
import ScrollToTop from "./ScrollToTop";

import Home from "./Home/Home";
import ContactUs from "./ReachUs/ContactUs";
import CareerPage from "./ReachUs/CareerPage/CareerPage";
import Insights from "./BlogPage/Insights";
import WhoWeAre from "./WhoWeAre/WhoWeAre";
import Enrol from "./WhatWeDo/Enrol";
import ProductPage from "./WhatWeDo/ProductPage";
import WebDevelopment from "./Services/WebDevelopment/WebDevelopment";

const BlogView = lazy(() => import("./BlogPage/BlogView/BlogView"));

const TermsAndConditions = lazy(() =>
  import("./TermsAndConditions/TermsAndConditions"),
);

const PrivacyPolicy = lazy(() => import("./PrivacyPolicy/PrivacyPolicy"));

const Forbidden = lazy(() => import("./ForbiddenPage/Forbidden"));

export default function App() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      autoRaf: false,
    });

    lenis.scrollTo(0, {
      immediate: true,
    });

    window.lenis = lenis;

    let animationFrame;

    const raf = (time) => {
      lenis.raf(time);
      animationFrame = requestAnimationFrame(raf);
    };

    animationFrame = requestAnimationFrame(raf);

    const resizeObserver = new ResizeObserver(() => {
      lenis.resize();
    });

    resizeObserver.observe(document.body);

    return () => {
      cancelAnimationFrame(animationFrame);
      resizeObserver.disconnect();
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/careers" element={<CareerPage />} />
        <Route path="/blog" element={<Insights />} />
        <Route path="/whoWeAre" element={<WhoWeAre />} />
        <Route path="/whatWeDo/Enrol" element={<Enrol />} />
        <Route path="/whatWeDo/:id" element={<ProductPage />} />
        <Route path="/services/web-development" element={<WebDevelopment />} />

        <Route
          path="/blog/:id"
          element={
            <Suspense fallback={null}>
              <BlogView />
            </Suspense>
          }
        />

        <Route
          path="/termsandconditions"
          element={
            <Suspense fallback={null}>
              <TermsAndConditions />
            </Suspense>
          }
        />

        <Route
          path="/privacypolicy"
          element={
            <Suspense fallback={null}>
              <PrivacyPolicy />
            </Suspense>
          }
        />

        <Route
          path="*"
          element={
            <Suspense fallback={null}>
              <Forbidden />
            </Suspense>
          }
        />
      </Routes>
      <FooterPage />
    </BrowserRouter>
  );
}